import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { checkFieldsValidity } from '../../shared/index';
import { ManageForeclosureAuctionService } from '../manage-foreclosure-auction.service';
import { ForeclosureAuction, ForeclosureAuctionSearchParams } from '../models/ForeclosureAuction';

@Component({
  selector: 'app-list-foreclosure-auction',
  templateUrl: './list-foreclosure-auction.component.html',
  styleUrls: ['./list-foreclosure-auction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ListForeclosureAuctionComponent implements OnInit {

  @Output() doeditBidInstructionEvent = new EventEmitter<boolean>();
  @Output() selectedBidInstruction = new EventEmitter<{}>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();

  @ViewChild('dt') table: Table;
  searchParams : ForeclosureAuctionSearchParams;
  listForeclosureAuctionForm: FormGroup;
  propertyState: any[];
  selectedPropertyState: any;
  county:any[];
  selectedCounty:any;
  data: ForeclosureAuction[];
  cols: { field: string; header: string; showInHeader: boolean; }[];
  records: number;
  loadingSearchResult: boolean = true;
  formSubmitted: boolean;
  selectedItems:ForeclosureAuction[];
  currentPageSlectedItems : ForeclosureAuction[];
  staturtaryValue : number;
  stateControl: any;
  countyControl: any;
  localStorageData:any;
  auctionAddress: string;
  auctionLocation: string;

  constructor(private manageForeclosureAuctionService : ManageForeclosureAuctionService) { }

  ngOnInit() {
    this.listForeclosureAuctionForm = new FormGroup({
      propertyState: new FormControl('', null),
      county: new FormControl('', null),
      locationAddress: new FormControl('', null),
      locationDetails: new FormControl('', null),
      statutaryLocation: new FormControl('', null),
    }, checkFieldsValidity(Validators.required));

    
    this.formSubmitted =  false;
    this.loadingSearchResult = false;
 //   this.staturtaryValue = 0;
    this.cols = [
      { field: 'State', header: 'Property State', showInHeader: true },
      { field: 'County', header: 'County', showInHeader: true },
      { field: 'StatutaryLocation', header: 'Statutory Location', showInHeader: true },
      { field: 'Action', header: 'Action', showInHeader: true },
      { field: 'FcMatrixID', header: 'Fc Matrix ID', showInHeader: false },
      { field: 'AuctionLocationDetails', header: 'Auction Location Details', showInHeader: false },
      { field: 'AuctionLocationAddress', header: 'Auction Location Address', showInHeader: false }
    ];
    this.localStorageData =  JSON.parse(localStorage.getItem("data"));
    this.manageForeclosureAuctionService.getStates().subscribe(data => {
      this.propertyState = data.filter(x => x.value != 'ALL');   
      if(this.localStorageData != null  && this.localStorageData.State.length > 0){
        this.searchParams = <ForeclosureAuctionSearchParams>{};
        this.selectedPropertyState =  this.propertyState.find(x => x.value == this.localStorageData.State);  
        this.populateCounty(true);
        this.localStorageData.LocationAddress.length > 0 ? (this.auctionAddress = this.localStorageData.LocationAddress,this.searchParams.LocationAddress = this.localStorageData.LocationAddress): (this.auctionAddress ='', this.searchParams.LocationAddress='');
        this.localStorageData.LocationDetails.length > 0 ? (this.auctionLocation = this.localStorageData.LocationDetails,this.searchParams.LocationDetails= this.localStorageData.LocationDetails): (this.auctionLocation ='', this.searchParams.LocationDetails='');
        this.staturtaryValue = this.localStorageData.StatutaryLocation;
        this.searchParams.StatutaryLocation = this.staturtaryValue.toString();
        this.searchParams.State = this.localStorageData.State;
        this.searchParams.County = this.localStorageData.County;
        this.getMatrixData();
      }
    });
  }

  populateCounty = (preSelect: boolean = false) : void => {
    this.manageForeclosureAuctionService.getCounty(this.selectedPropertyState.value).subscribe(res => {
      this.county = res.data; 
      if(preSelect && this.localStorageData != null  && this.localStorageData.County.length > 0){
        this.selectedCounty =  this.county.find(x => x.value == this.localStorageData.County);
        this.searchParams.County = this.localStorageData.County;
      }
    })
  }

  deleteSelected = () : void => {
    const matrixIds = this.selectedItems.map((arrayObject)=>{return arrayObject.FcMatrixID}).join(",");
    this.manageForeclosureAuctionService.delete(matrixIds).subscribe(res => {
      let result =  res.data[0];
      if(result.STATUS == 'Success' && result.NUMBEROFRECORDSDELETED > 0){
        this.onSubmitListForeclosureAuctionForm();
      }
    },error=>{
      console.log(error.message);
    });
  }

  onTableHeaderCheckboxToggle = (event) =>{
    let startRow = this.table.first;
    let range = startRow + (this.table.rows);
    this.currentPageSlectedItems = [];
    this.data.map((item, index) => {
      if (index >= startRow && index < range) {
        this.currentPageSlectedItems.push(item);
      }
    })
    this.selectedItems = [];
    this.selectedItems = this.currentPageSlectedItems;
  }

  isPaginatorVisible = (): boolean => {
    return (this.data && this.data.length > 0) ? true : false;
  }

  resetForm = () => {
    this.formSubmitted =  false;
    this.listForeclosureAuctionForm.reset();
    this.data = [];
    localStorage.clear();
  }

  resetSelections = (e) =>{
    this.selectedItems = [];
  }

  onSubmitListForeclosureAuctionForm(): void{
    this.setSearchParams();
    this.getMatrixData();
  }
  
  getMatrixData() :void {
    this.data = [];
    this.loadingSearchResult = true;
    this.selectedItems = [];
    this.formSubmitted =  true;
    if(this.table){
      this.table.first = 0;
    }
    this.manageForeclosureAuctionService.getForeclosureAuctionLocationData(this.searchParams).subscribe(res=> {
      this.data = res.data;
      this.records =  res.meta.pagination.TotalRecords;
      this.loadingSearchResult = false;
    })
  }

  setSearchParams(): void {
    this.searchParams = <ForeclosureAuctionSearchParams>{};
    this.searchParams.State = this.listForeclosureAuctionForm.value.propertyState == (null || undefined) ? '' : this.listForeclosureAuctionForm.value.propertyState.value;
    this.searchParams.County = this.listForeclosureAuctionForm.value.county == (null || undefined) ? '' : this.listForeclosureAuctionForm.value.county.value;
    this.searchParams.LocationAddress = this.listForeclosureAuctionForm.value.locationAddress == (null || undefined) ? '' : this.listForeclosureAuctionForm.value.locationAddress;
    this.searchParams.LocationDetails = this.listForeclosureAuctionForm.value.locationDetails == (null || undefined) ? '' : this.listForeclosureAuctionForm.value.locationDetails;
    this.searchParams.StatutaryLocation = this.listForeclosureAuctionForm.value.statutaryLocation == (null || undefined) ? '' : this.listForeclosureAuctionForm.value.statutaryLocation;
    localStorage.setItem("data", JSON.stringify(this.searchParams));
  }

  showEditForeclosureAuction(data: ForeclosureAuction): any {
    this.doeditBidInstructionEvent.emit(true);
    this.selectedBidInstruction.emit(data);
    this.setBreadCrumbs.emit([{label: 'Manage Foreclosure Auction Location' },{ label: 'Edit ForeClosure Auction Location'}]);
  } 

}
